<template>

	<div class="container page-login">

		<h1 class="mt-5 mb-3 text-center">Theme Deploy</h1>

		<div v-if="error" class="alert alert-danger">{{ error }}</div>

		<div class="w-50 mx-auto">
			<div class="card">
				<div class="card-header">{{_lang('Password recovery')}}</div>
				<div class="card-body">

					<form @submit.prevent="onSubmit">
						<div class="form-group">
							<label>E-mail</label>
							<input type="text" class="form-control" v-model="login.email" required>
						</div>
						<button type="submit" class="btn btn-primary">{{_lang('Recover')}}</button>
					</form>


				</div>
			</div>
			<p class="text-center mt-3">
				<router-link to="login">{{_lang('Back to login')}}</router-link>
			</p>

		</div>
	</div>


</template>

<script>

	import axios from 'axios';

	export default {
		data() {
			return {
				error:'',
				login:{
					email:'',
				},
			}
		},

		methods:{

			onSubmit(){
				this.error = '';
				axios({
					method: 'post',
					url: '/api/forgot',
					data: this.login
				}).then((res)=>{
					alert('mensagem enviada');
				}).catch((error)=>{
					this.error = error.response.data;
				});

			},
		},
		mounted(){
		}

	}



</script>

